import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Checkbox } from 'common/TailwindComponents';
import Notifier from 'common/helpers/Notifier';
import { BarLoader } from '@unite-us/ui';

const MarkAsUrgentCheckbox = ({
  id,
  checked: initialChecked,
  onUpdate,
}) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const [checked, setChecked] = useState(initialChecked ?? false);

  useEffect(() => {
    setChecked(initialChecked ?? false);
  }, [initialChecked]);

  const handleChange = async (event) => {
    const newCheckedState = event.target.checked;
    setChecked(newCheckedState);
    setIsUpdating(true);

    try {
      await onUpdate(
        id,
        { urgent: newCheckedState },
        newCheckedState ? 'Request marked as urgent' : 'Request unmarked as urgent',
      );
    } catch (error) {
      setChecked(!newCheckedState);
      Notifier.dispatch('error', 'Failed to update urgent status. Please try again.');
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <>
      {initialChecked === undefined ? <BarLoader /> : (
        <div className="flex items-center">
          <Checkbox
            id="mark-as-urgent-checkbox"
            ariaLabel="Mark as urgent"
            checked={checked}
            onChange={handleChange}
            disabled={isUpdating}
            label={checked ? 'Urgent' : 'Mark as Urgent'}
            labelClassName={cx('ml-2 text-sm capitalize', checked ? 'medium-font' : 'regular-font')}
            labelStyle={{ color: checked ? 'var(--color-red)' : 'var(--color-text-blue)' }}
          />
        </div>
      )}
    </>
  );
};

MarkAsUrgentCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired,
};

MarkAsUrgentCheckbox.defaultProps = {
  checked: undefined,
};

export default MarkAsUrgentCheckbox;
